import { Address, Provider, getContract } from 'nftx.js';
import { Pool } from '@nftx/abi';

const fetchPoolCurrentTick = async ({
  poolId,
  provider,
}: {
  poolId: Address;
  network: number;
  provider: Provider;
}) => {
  const contract = getContract({
    address: poolId,
    abi: Pool,
    provider,
  });

  const slot = await contract.read.slot0({});
  const [_sqtPrice, tick] = slot;

  return BigInt(tick);
};

export default fetchPoolCurrentTick;
